export default [
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "costs",
      layout: "dashboard",
    },
    path: "/costs",
    name: "costs",
    component: () => import("@/layouts/index/CostIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Liste des coûts",
          layout: "dashboard",
        },
        path: "index",
        name: "costs-index",
        component: () => import("@/views/costs/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Créer un coût",
          layout: "dashboard",
        },
        path: "create",
        name: "costs-create",
        component: () => import("@/views/costs/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier le coût",
          layout: "dashboard",
        },
        path: ":reference/edit",
        name: "costs-edit",
        component: () => import("@/views/costs/Edit.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Détails du coût",
          layout: "dashboard",
        },
        path: ":reference/details",
        name: "costs-details",
        component: () => import("@/views/costs/Details.vue"),
      },
    ],
  },
];

